import React from 'react';
import { MoveLarge } from '@wix/wix-ui-icons-common/system';
import { stVars } from '../../Foundation/stylable/colors.st.css';
const DragHandle = () => React.createElement(MoveLarge, { style: { color: stVars.D80 } });
DragHandle.displayName = 'MediaOverlay.DragHandle';
export default DragHandle;
//# sourceMappingURL=DragHandle.js.map